import { get, post, put, del } from '../utils/request';
import { Campus, PaginatedResponse } from '../types';

// 获取校区列表
export async function getCampusList(params?: any): Promise<PaginatedResponse<Campus>> {
  return get<PaginatedResponse<Campus>>('/admin/campuses', params);
}

// 获取所有校区（下拉选择）
export async function getAllCampuses(): Promise<Campus[]> {
  return get<Campus[]>('/admin/campuses/all');
}

// 创建校区
export async function createCampus(data: Partial<Campus>): Promise<{ id: string; campusCode: string }> {
  return post('/admin/campuses', data);
}

// 更新校区
export async function updateCampus(id: string, data: Partial<Campus>): Promise<void> {
  return put(`/admin/campuses/${id}`, data);
}

// 获取校区详情
export async function getCampusDetail(id: string): Promise<Campus> {
  return get<Campus>(`/admin/campuses/${id}`);
}

// 删除校区
export async function deleteCampus(id: string): Promise<void> {
  return del(`/admin/campuses/${id}`);
}
